import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

type Props = {
  url: string;
};

export const BodyBackgroundImage: React.FC<Props> = ({ url }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    const image = new Image();
    image.onload = () => {
      setIsLoaded(true);
    };
    image.src = url;
  }, []);

  return ReactDOM.createPortal(
    <div
      className={`body-background ${isLoaded ? 'body-background--loaded' : ''}`}
      style={{ backgroundImage: `url(${url})` }}
    />,
    document.body,
  );
};
